/**
 * Stories implemented
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FC } from 'react';
import { Spinner, Flex } from '@zillow/constellation';
import styled from 'styled-components';

const StyledLoadingScreen = styled(Flex)`
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
`;

/**
 * Renders a spinner experience while the authentication decision is pending.
 */
export const AuthenticationIsLoading: FC = () => (
    <StyledLoadingScreen suppressHydrationWarning>
        <Spinner size="lg" suppressHydrationWarning />
    </StyledLoadingScreen>
);
